import React, { useEffect, useState } from 'react';
import { Paper, Typography, makeStyles, Box, CircularProgress } from '@material-ui/core';

import { getCustomer_GetCustomerPolicy } from '../../../../Core/Services/InternalUser/ControllerService/customerService';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(0)
    },
    title: {
        fontSize: 18,
        fontWeight: 600,
        marginBottom: theme.spacing(2)
    },
    container: {
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(2),
        borderRadius: 10
    },
    policyCard: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: 8,
        backgroundColor: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 6px 14px rgba(0,0,0,0.12)',
            transform: 'translateY(-2px)'
        }
    },
    policyTitle: {
        fontWeight: 600,
        fontSize: 15,
        marginBottom: theme.spacing(1)
    },
    description: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        lineHeight: 1.6
    },
    emptyText: {
        textAlign: 'center',
        padding: theme.spacing(3),
        color: theme.palette.text.secondary
    },
    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(4)
    }
}));

const CustomerPolicyModal = ({ customerID }) => {
    const classes = useStyles();

    const [policies, setPolicies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchPolicies() {
            if (!customerID) return;

            setLoading(true);

            const res = await getCustomer_GetCustomerPolicy(customerID);

            if (res.success && res.data?.details) {
                setPolicies(res.data.details);
            }

            setLoading(false);
        }

        fetchPolicies();
    }, [customerID]);

    return (
        <div className={classes.wrapper}>
            {loading ? (
                <div className={classes.loaderWrapper}>
                    <CircularProgress size={30} />
                </div>
            ) : policies.length === 0 ? (
                <Typography className={classes.emptyText}>No policies available.</Typography>
            ) : (
                <Box className={classes.container}>
                    {policies.map((policy) => (
                        <Paper key={policy.customerPolicyID} className={classes.policyCard} elevation={0}>
                            <Typography className={classes.policyTitle}>{policy.customerPolicyTitle}</Typography>

                            <Typography
                                component="div"
                                className={classes.description}
                                dangerouslySetInnerHTML={{
                                    __html: policy.customerPolicyDescription
                                }}
                            />
                        </Paper>
                    ))}
                </Box>
            )}
        </div>
    );
};

export default CustomerPolicyModal;
